import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { actions as JobActions, selectors as JobSelectors } from "store/modules/jobs";
import TableComponent from "../TableComponent";

const UnFilledPage = (props) => {
  const dispatch = useDispatch();
  const pageInfo = useSelector(JobSelectors.getTodayUnfilledPaginationData)
  const jobListData = useSelector(JobSelectors.getListData({ timeframe: 'today', status: 'unfilled', part: "data" }))
  const pageFilter = useSelector(JobSelectors.getListData({ timeframe: 'today', status: 'unfilled', part: "filter" }))
  const pageSort = useSelector(JobSelectors.getListData({ timeframe: 'today', status: 'unfilled', part: "sort" }))
  const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
    dispatch(JobActions.setTodayUnfilledPageSize(pageSize));
    dispatch(JobActions.setTodayUnfilledFilter(filters));
    dispatch(JobActions.setTodayUnfilledSort(sortBy));
    dispatch(JobActions.fetchTodayUnfilledJobs(pageIndex));
  }, []);

  return <TableComponent pageInfo={pageInfo} jobListData={jobListData} pageFilter={pageFilter} pageSort={pageSort} fetchData={fetchData} history={props.history} />
}

export default UnFilledPage